import { Components_Chip_51BC9844, ComponentsModule_Chip_Level } from "../Chip.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { Tickets_severity } from "../../Locale.js";
import { createObj } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import Warning from "@mui/icons-material/Warning";

function Tickets_severityColor_5E2CD6A8(severity) {
    switch (severity.tag) {
        case 1:
            return new ComponentsModule_Chip_Level(4, []);
        case 2:
            return new ComponentsModule_Chip_Level(4, []);
        case 3:
            return new ComponentsModule_Chip_Level(3, []);
        case 4:
            return new ComponentsModule_Chip_Level(2, []);
        case 5:
            return new ComponentsModule_Chip_Level(5, []);
        default:
            return new ComponentsModule_Chip_Level(4, []);
    }
}

export function Tickets_SeverityChip_5E2CD6A8(tickets_SeverityChip_5E2CD6A8InputProps) {
    const severity = tickets_SeverityChip_5E2CD6A8InputProps.severity;
    const ctx = reactApi.useContext(ctx_1);
    const colorLevel = Tickets_severityColor_5E2CD6A8(severity);
    return createElement(Components_Chip_51BC9844, {
        key: "",
        $key: "",
        primary: Tickets_severity(ctx.Locale, severity),
        enabled: true,
        startIcon: (props) => {
            const props_2 = createObj(props);
            return react.createElement(Warning, props_2);
        },
        colorLevel: colorLevel,
    });
}

